"use client";

/**
 * Provider router for the Scheduler question widget.
 *
 * Calendly + Cal.com mount their official embed widgets via `EmbedSchedulerSlot`.
 * Google Calendar uses our in-form picker + Calendar API (`CustomCalendarSlot`).
 */

import { FormJourneyItem, SchedulerSettings } from "@plura/shared/types";
import CustomCalendarSlot from "./CustomCalendarSlot";
import EmbedSchedulerSlot from "./embed/EmbedSchedulerSlot";
import { getSchedulerEmbedProvider } from "./embed/providers";
import "./scheduler-screen.css";

interface Props {
  step: FormJourneyItem;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  handleAnswer?: () => void;
  embeddedInline?: boolean;
}

const SchedulerSlot = (props: Props) => {
  const slotClassName = props.embeddedInline ? "schedulerSlot schedulerSlot--inline" : "schedulerSlot";
  const provider = (() => {
    const parsed = SchedulerSettings.safeParse(props.step.schedulerSettings);
    return parsed.success ? parsed.data.provider : null;
  })();

  if (provider === "GOOGLE_CALENDAR" || (props.previewMode && !provider)) {
    return (
      <div className={slotClassName}>
        <CustomCalendarSlot {...props} />
      </div>
    );
  }

  const embedProvider = provider ? getSchedulerEmbedProvider(provider) : null;

  if (!embedProvider) {
    return (
      <div className={slotClassName}>
        <div className="embedError">This scheduler provider is not supported yet.</div>
      </div>
    );
  }

  return (
    <div className={slotClassName}>
      <EmbedSchedulerSlot {...props} provider={embedProvider} />
    </div>
  );
};

export default SchedulerSlot;
